import {BaseDTO} from '../../common/models/BaseDTO';
import {NameValueDTO} from '../../common/models/NameValueDTO';
import {SettlementDiscountDTO} from './SettlementDiscountDTO';
import {CodingSchemaDTO} from './CodingSchemaDTO';
import {ProductDTO} from './ProductDTO';

export class PriceListDTO extends BaseDTO {
  providerPriceListId: number;
  name: string;
  code: string;
  administrator: NameValueDTO;
  providerPriceListType: NameValueDTO;
  settlementDiscounts: SettlementDiscountDTO[];
  providerNetworkPriceLists: ProviderPriceListLinkDTO[];
  providerPriceLists: ProviderPriceListLinkDTO[];
  productPriceLists: ProductPriceListLinkDTO[];
}

export class ProviderPriceListLinkDTO extends BaseDTO {
  providerNetwork: NameValueDTO;
  provider: NameValueDTO;
  codingSchema: CodingSchemaDTO;
  proprietaryCode: string;
  proprietaryDescription: string;
  grossAmount: number;
  discountAmount: number;
  netAmount: number;
  startDate: Date;
  endDate: Date;
  currency: NameValueDTO;
}

export class ProductPriceListLinkDTO extends BaseDTO {
  product: ProductDTO;
}
